import { render, staticRenderFns } from "./RequestDisorderDemographicInfo.vue?vue&type=template&id=fef2c462&scoped=true&"
import script from "./RequestDisorderDemographicInfo.vue?vue&type=script&lang=js&"
export * from "./RequestDisorderDemographicInfo.vue?vue&type=script&lang=js&"
import style0 from "./RequestDisorderDemographicInfo.vue?vue&type=style&index=0&id=fef2c462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef2c462",
  null
  
)

export default component.exports